import React from 'react';

import { createRoot } from 'react-dom/client';

import { ENumerologyType, isNumerologyType } from '../../components/container/NumerologyCalculator/constants';

import NumerologyCalculator from '../../components/container/NumerologyCalculator';

import applyThemeAndTranslate from '../../Hooks/Common/applyThemeAndTranslate';

const MOUNT_TAG = 'numerology-calculator';
const MOUNTED_ATTR = 'data-numerology-calculator-mounted';

const TranslatedNumerologyCalculator = applyThemeAndTranslate(NumerologyCalculator);

const bootstrap = (): void => {
    document.querySelectorAll<HTMLElement>(MOUNT_TAG).forEach((element) => {
        if (element.hasAttribute(MOUNTED_ATTR)) return;
        element.setAttribute(MOUNTED_ATTR, '');

        const { type } = element.dataset;

        createRoot(element).render(
            <TranslatedNumerologyCalculator type={isNumerologyType(type) ? type : ENumerologyType.NAME} />
        );
    });
};

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap, { once: true });
} else {
    bootstrap();
}
